import { qs, qsa, addGlobalEventListener } from './utils.js';

const cart = $$('[data-cart]');

gsap.set(cart, {
  pointerEvents:"all",
  x:0,
  opacity:1
})

const openCart = gsap.from(cart, {
    pointerEvents:"none",
    x:"200%",
    opacity:0
    // opacity:1
}).reverse();

function toggleCart(onlyOpen) {            
  if(onlyOpen === undefined){
    openCart.reversed(!openCart.reversed())      
  }else if(onlyOpen === false){
    openCart.reversed(true);
  }else if(onlyOpen === true){
    openCart.reversed(false);
  }
}

document.addEventListener('DOMContentLoaded', ()=>{
    // $('#cart.loading').classList.remove('loading')
})

const menu = $('#menu');

gsap.set(menu, {
  pointerEvents:"all",
  opacity:1,
  
})

const openMenu = gsap.from(menu, {
  pointerEvents:'none',
  opacity:0
}).reverse();

function toggleMenu(onlyOpen){
  if(onlyOpen === undefined){
    openMenu.reversed(!openMenu.reversed())
  }else if(onlyOpen === false){
    openMenu.reversed(true);
  }else{
    openMenu.reversed(false);
  }
}



function toggleMobileMenu() {    
    document.querySelector('#mm').classList.toggle('dn');
}

addGlobalEventListener("click", ".mm-trigger", e => {
    toggleMobileMenu();
})


document.querySelectorAll('*[data-mm-trigger]').forEach((button) =>
      button.addEventListener('click', function(event) {
        toggleMobileMenu()
      })
);

document.querySelectorAll('*[data-qc-trigger]').forEach((button) =>{
      button.addEventListener('click', function(event) {
        if(button.dataset.qcTrigger == "open"){
          toggleCart(true)
        }else if(button.dataset.qcTrigger == "close"){
          toggleCart(false)
        }else{
          toggleCart();
        }
      })
    }
);

document.querySelectorAll('*[data-mobile-menu]').forEach((button)=>{
  button.addEventListener('click', (ev)=>{
    if(button.dataset.mobileMenu == "open"){
      toggleMenu(true)
    }else if(button.dataset.mobileMenu == "close"){
      toggleMenu(false)
    }else{
      toggleMenu()
    }
  })
})

// Toggle Sibling element
function toggleSibling(toggle) {
  var target = toggle.nextElementSibling,
  currentState = toggle.getAttribute('data-sibling-toggle')
  toggle.setAttribute('data-sibling-toggle', !currentState);
  target.classList.toggle('dn')
}

document.querySelectorAll('*[data-sibling-toggle]').forEach((button) =>
      button.addEventListener('click', function(event) {
        toggleSibling(button);
      })
);